import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { DataService } from '../../core/data.service';
import { UserAccount } from './creditor-login.model';
import { TermsAndConditionsService } from 'src/app/pages/terms-and-conditions/terms-and-conditions.service';
import { TermsandConditions } from 'src/app/pages/terms-and-conditions/terms-and-conditions.model';
import { environment } from 'src/environments/environment';
import { OAuthService } from 'src/app/shared/oAuth/oauth-service';
import { authCodeFlowConfig } from 'src/app/shared/oAuth/oAuth.config';
import { filter } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { FieldLength } from 'src/app/shared/general/field-length';
import { MaintenanceService } from 'src/app/shared/services/maintenance.service';
import { Maintenance } from 'src/app/shared/models/maintenance.model';
import { PortalTypeEnum } from 'src/app/shared/general/portal-type-enum';
import * as moment from 'moment';
import { LocationStrategy } from '@angular/common';
import { WarningMessageEnum } from 'src/app/shared/general/warning-message.enum';

@Component({
  selector: 'app-creditor-login',
  templateUrl: './creditor-login.component.html',
  styleUrls: ['./creditor-login.component.scss'],
})
export class CreditorLoginComponent implements OnInit {
  termsAndConditionId: string;
  termsAndCondition: TermsandConditions;
  showTermsAndConditionPage: boolean;
  products = [];
  labelCaption: any = null;
  showModal: boolean;
  registerForm: UntypedFormGroup;
  submitted = false;
  userAccount: UserAccount = new UserAccount();
  showEmailIdNotExistAlert: boolean;
  alertMessage: any;

  fieldLength = FieldLength;
  showWelcomePage: boolean;
  accountManageRoleId = 1;
  isCIAMRequired: boolean = false;
  returnUrl: string;
  routeURL: any;
  routeObj: any;
  isUserLoggedIn: boolean;
  skipLandingPage: boolean = false;
  showMaintenanceNotice:boolean=false;
  maintenanceDetail:Maintenance= new Maintenance();
  isServerDataLoaded:boolean=false;
  isServerUnavailable:boolean=false;
  siteDownLabels:any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private formBuilder: UntypedFormBuilder,
    private dataService: DataService,
    public dialog: MatDialog,
    private termsAndConditionsService: TermsAndConditionsService,
    private oAuthService: OAuthService,
    private route: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private maintenanceService: MaintenanceService,
    private locationStrategy: LocationStrategy
  ) {
    //To check is server down. If yes show appropriate screen
    if (sessionStorage.getItem("isServerUnavailable")=="true") {
      this.isServerUnavailable = true;
      this.preventBackButton();
      //Set background image
      this.setMaintenanceBackgroundImage();
    }
    //Logic to get Maintenance Details and set prior message
    this.getMaintenanceDetail();
   
  }
  getMaintenanceDetail(){
    this.spinnerService.show();
    //sessionStorage.setItem('showMaintenancePriorMessage',"false");
    //sessionStorage.setItem('scheduledMaintenanceDateTime',"");
    this.maintenanceService.getMaintenanceDetail(PortalTypeEnum.CreditorCentralPortal, sessionStorage.getItem('userId') != "" && sessionStorage.getItem('userId') != null ? true : false, sessionStorage.getItem('userId'))
      .subscribe((maintenanceResponse: Maintenance) => {
        this.spinnerService.hide();
        if (maintenanceResponse != null && maintenanceResponse?.scheduledDateTime != null) {
          this.maintenanceDetail = maintenanceResponse;
          //Set all maintenance Data in Service
          this.maintenanceService.setScheduledMaintenanceDateTime(this.maintenanceDetail.scheduledDateTime);
          //Prevent bak butto based on session flag
          if (this.maintenanceDetail?.isMaintenanceInProgress) {
            if (sessionStorage.getItem("preventBackButton") == "true") {
              this.preventBackButton();
            }
            //Set background image
            this.setMaintenanceBackgroundImage();
          }
        }
        this.isServerDataLoaded = true;
      }, error => {
        this.spinnerService.hide();
        this.isServerDataLoaded = true;
        //To check is server down. If yes show appropriate screen
        if (sessionStorage.getItem("isServerUnavailable")=="true") {
          this.isServerUnavailable = true;
          this.preventBackButton();

          //Set background image
          this.setMaintenanceBackgroundImage();
        }
      });
  }
  show() {
    if (!this.isCIAMRequired) {
      this.showModal = true; // Show-Hide Modal Check
    }
    else {
      if (sessionStorage.getItem('isLoginInProgress') == null || sessionStorage.getItem('isLoginInProgress') == '') {
        sessionStorage.setItem('isLoginInProgress', 'true')
        this.oAuthService.configure(authCodeFlowConfig);
        this.oAuthService.loadDiscoveryDocumentAndLogin();
        this.oAuthService.setupAutomaticSilentRefresh();
      }
    }
  }
  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
    this.userAccount.emailAddress = null;
    this.submitted = false;
    this.showEmailIdNotExistAlert = false;
  }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    
    this.isServerUnavailable = this.activatedRoute.snapshot.paramMap.get('isServerUnavailable') == 'true';
    this.onRandomBackgroundImageChange()
    this.isCIAMRequired = environment.isCIAMRequired == 'true';
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'empty';
    if (!sessionStorage.getItem('returnURL'))
      sessionStorage.setItem('returnURL', this.returnUrl);

    if (sessionStorage.getItem('returnURL') && sessionStorage.getItem('returnURL') != 'empty') {
      this.returnUrl = sessionStorage.getItem('returnURL');
    }
    if (this.isCIAMRequired && sessionStorage.getItem('isLoginInProgress')) {
      this.skipLandingPage = true;
      this.spinnerService.show();
      this.oAuthService.configure(authCodeFlowConfig);
      this.oAuthService.loadDiscoveryDocumentAndLogin();
      this.oAuthService.setupAutomaticSilentRefresh();
      this.oAuthService.events
        .pipe(filter((e) => e.type === 'token_received'))
        .subscribe((_) => {
          this.getUserProfileAndRedirect();
          sessionStorage.setItem('isLoginInProgress', '')
        });
      this.oAuthService.events
        .pipe(filter((e) => e.type === 'token_refreshed'))
        .subscribe((_) => {
          this.getUserProfile();
        });
    }
    let data = this.utilitiesService.GetLabelCaption(
      this.activatedRoute.snapshot.data.labelCaptionData,
      'Module_CreditorLogin'
    );
    if (data && data['Label']) {
      this.labelCaption = data['Label'];
    }
    if (data && data['Alert']) {
      this.alertMessage = data['Alert'];
    }
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.fieldLength.EmailIdPattern)]],
    });
    if (this.returnUrl != undefined && this.returnUrl != 'empty') {
      this.show();
    }
    //To set site down labels
    this.siteDownLabels={
      labelOne:WarningMessageEnum.SiteDownLabelOne,
      labelTwo:WarningMessageEnum.SiteDownLabelTwo,
      labelThree:WarningMessageEnum.SiteDownLabelThree
    }
  }


  get f() { return this.registerForm.controls; }
  onSubmit() {
    if (!this.isCIAMRequired) {
      this.submitted = true;
      // stop here if form is invalid
      if (this.registerForm.invalid) {
        return;
      }
      let checkEmailAddress: any = {};
      checkEmailAddress.emailId = this.userAccount.emailAddress;
      let path: string = 'home/GetUserAccountByEmailId';
      this.dataService.postRequest(path, checkEmailAddress).subscribe((userDetailsResponse: any) => {
        if (userDetailsResponse != null) {
          sessionStorage.setItem('id_token', userDetailsResponse.token);
          this.returnUrl = this.route.snapshot.queryParams['returnUrl']
          this.getUserProfileAndRedirect();
        }
        else {
          this.showEmailIdNotExistAlert = true;
        }
        this.submitted = false;
      });
    }
  }
  onKeyForEmail(): void {
    this.showEmailIdNotExistAlert = false;
  }

  redirectToRegistrationGuideline() {
    sessionStorage.clear();
    this.router.navigate(['RegistrationGuideline']);
  }
  redirectToCreditorHomepage(userDetailsResponse: any) {
    var userId = userDetailsResponse.userId;
    sessionStorage.setItem('userId', userId);
    var emailId = userDetailsResponse.emailAddress;
    sessionStorage.setItem('emailId', emailId);
    var userName = userDetailsResponse.firstName + ' ' + userDetailsResponse.lastName;
    sessionStorage.setItem('userName', userName);
    sessionStorage.setItem('roleId', userDetailsResponse.roleId);
    this.showTermsAndConditionPage = true;
    if(this.returnUrl=='empty'|| this.returnUrl==undefined || this.returnUrl=='/')
    this.redirectToHomePageOrTermsCondition(userId, userDetailsResponse.isUserLoggedIn);
    else{
    this.validateURL();
    this.navigateByRouteParameter();
    }

  }

  public onNoClick() {
    this.userAccount.emailAddress = null;
    this.hide();
  }
  redirectToHomePageOrTermsCondition(userId: string, isUserLoggedIn: boolean) {
    this.termsAndConditionsService.getTermsAndConditionIdByUserId(userId).subscribe((response) => {
      if (response) {
        this.termsAndConditionId = response;
        this.termsAndConditionsService.getTermsandConditions(this.termsAndConditionId).subscribe((apiResponse: TermsandConditions) => {
          if (apiResponse) {
            this.termsAndCondition = apiResponse;
            if (this.termsAndCondition.isContentUpdated) {
              this.router.navigate(['terms-and-conditions', {
                userId: userId, showWelcomePage: this.showWelcomePage,
                isUserLoggedIn: isUserLoggedIn
              }]);
            }
            else {
              if (!this.isUserLoggedIn) {
                this.isUserLoggedIn = true;
                let updateUserAccount = {
                  userId: sessionStorage.getItem('userId'),
                  termsAndConditionId: this.termsAndCondition.id,
                  isUserLoggedIn: this.isUserLoggedIn
                };

                this.termsAndConditionsService.putRequestToUpdateTermsAndConditionId(updateUserAccount).
                  subscribe((updateResponse: any) => {
                    if (updateResponse) {
                      this.router.navigate(['creditorhome']);
                    }
                  });
              }
              else {
                this.router.navigate(['creditorhome']);
              }
            }
          }
        });
      }
    });

  }
  private getUserProfileAndRedirect() {
    this.dataService.getUserProfile().subscribe((res: any) => {
      this.dataService.userProfile = res;
      this.dataService.isLoginInProgress = false;
      this.isUserLoggedIn = res.isUserLoggedIn
      if (!res.isUserLoggedIn && res.termsAndConditionsId == null) {
        this.showWelcomePage = true;
      }
      if (this.skipLandingPage)
        this.spinnerService.hide();
      this.skipLandingPage = false;
      //load maintenance data
      this.spinnerService.show();
      this.maintenanceService.getMaintenanceDetail(PortalTypeEnum.CreditorCentralPortal, res?.userId != "" && res?.userId != null ? true : false, sessionStorage.getItem('userId'))
        .subscribe((maintenanceResponse: Maintenance) => {
          this.spinnerService.hide();
          if (maintenanceResponse != null && maintenanceResponse?.scheduledDateTime != null) {
            this.maintenanceDetail = maintenanceResponse;
             //Set all maintenance Data in Service
            this.maintenanceService.setScheduledMaintenanceDateTime(this.maintenanceDetail?.scheduledDateTime);
            this.maintenanceService.setMaintenanceBeforeHourList(this.maintenanceDetail.maintenanceBeforeHourList);
            this.maintenanceService.setMaintenanceBeforeMinuteList(this.maintenanceDetail.maintenanceBeforeMinuteList);
            this.maintenanceService.setMaintenanceBeforeSecondList(this.maintenanceDetail.maintenanceBeforeSecondList);

            //Logic to remove past hour, minutes and seconds from the maintenance response list
            this.maintenanceService.removePastDateTime();
            //At first load start the timer from app component by subcribing to timer
          this.maintenanceService.setMaintenanceWarningPopupSubject(this.maintenanceDetail?.scheduledDateTime);
            //Prevent bak butto based on session flag
            if (this.maintenanceDetail?.isMaintenanceInProgress) {
              if (sessionStorage.getItem("preventBackButton") == "true") {
                this.preventBackButton();
              }
              //Set background image
              this.setMaintenanceBackgroundImage();
            }
            else{
              this.redirectToCreditorHomepage(res);
            }
          }
          this.isServerDataLoaded = true;
          this.redirectToCreditorHomepage(res);
        }, error => {
          this.spinnerService.hide();
          this.isServerDataLoaded = true;
          //To check is server down. If yes show appropriate screen
          if (sessionStorage.getItem("isServerUnavailable")=="true") {
            this.isServerUnavailable = true;
            this.preventBackButton();
  
            //Set background image
            this.setMaintenanceBackgroundImage();
          }
        });

    });
  }
  private getUserProfile() {
    this.dataService.getUserProfile().subscribe((res: any) => {
      this.dataService.userProfile = res;
      var userId = res.userId;
      sessionStorage.setItem('userId', userId);
      var emailId = res.emailAddress;
      sessionStorage.setItem('emailId', emailId);
      var userName = res.firstName + ' ' + res.lastName;
      sessionStorage.setItem('userName', userName);
      sessionStorage.setItem('roleId', res.roleId);
      //load maintenance data
      this.getMaintenanceDetail();
    });
  }

  navigateByRouteParameter() {
    sessionStorage.removeItem('returnURL');
    if (this.routeObj) {
      this.router.navigate([this.routeURL, this.routeObj]);
    }
    else {
      this.router.navigate([this.routeURL]);
    }
  }

  private validateURL() {
    let obj = {};
      var url = this.returnUrl.split('?');
      this.routeURL = url[0];
      if (url[1]) {
        var enc = decodeURIComponent(url[1].toString())
        enc = enc.replace("==","");
        enc = enc.replace("=","");
        enc = enc.replace("__","");
        var dec = window.atob(enc)
        //url[1] = atob(url[1]);
        // url[1] = url[1].replace('{', '');
        // url[1] = url[1].replace('}', '')
        dec = dec.replace("''", "'");

        if (dec) {
          let components = dec.split(';');
          components.forEach(c => {
            let kvPair = c.split('=');
            obj[kvPair[0]] = kvPair[1]
          })
          if (obj) {
            this.routeObj = obj;
            if (this.routeObj['broadcastId']) {
              sessionStorage.setItem('broadcastId', this.routeObj['broadcastId']);
            }
          }
        }
      }
  }

  public backgroundImageName: any = null;
  private onRandomBackgroundImageChange() {
    var randomNumber = Math.floor((Math.random() * 4) + 1);
    this.backgroundImageName = backgroundImages[randomNumber].imageName;
  }
  //A method ot prevent back button
  preventBackButton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  } 
  //A method to set specific background image based on busines requirement
  setMaintenanceBackgroundImage(){
    this.backgroundImageName = backgroundImages[1].imageName;
  }
}


export const backgroundImages = {
  1: {
    imageName: 'back-gd-screen1.jpg'
  },
  2: {
    imageName: 'back-gd-screen2.jpg',
  },
  3: {
    imageName: 'back-gd-screen3.jpg',
  },
  4: {
    imageName: 'back-gd-screen4.png'
  }
};
